<template>
<div class="container-fuild">
    <loading :active.sync="isLoading"></loading>
    <div class="col-12">
        <h3>案場狀態</h3>
    </div>
    <div class="col-12">
        <ul class="nav nav-tabs">
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '0'}" @click="visible = '0'" value="0">全部</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '1'}" @click="visible = '1'" value="1">雲林</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '2'}" @click="visible = '2'" value="2">台中</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '3'}" @click="visible = '3'" value="3">南投</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '4'}" @click="visible = '4'" value="4">台南</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '5'}" @click="visible = '5'" value="5">彰化</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '6'}" @click="visible = '6'" value="6">苗栗</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '7'}" @click="visible = '7'" value="7">嘉義</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === '8'}" @click="visible = '8'" value="8">屏東</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === 'A'}" @click="visible = 'A'" value="A">桃園</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === 'F'}" @click="visible = 'F'" value="F">工廠</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === 'Z'}" @click="visible = 'Z'" value="Z">凱文</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === 'X'}" @click="visible = 'X'" value="X">信宇</a>
            </li>
            <li class="nav-item">
                <a :class="{'nav-link': true, 'active': visible === 'ch'}" @click="visible = 'ch'" value="ch">選取</a>
            </li>
        </ul>
        <table class="table">
            <thead class="thead-light">
                <tr>
                    <th scope="col">選取</th>
                    <th scope="col">#</th>
                    <th scope="col">地點</th>
                    <th scope="col">安裝量</th>
                    <th scope="col">即時發電量</th>
                    <th scope="col">今日度數</th>
                    <th scope="col">日發電效率</th>
                    <th scope="col">累積度數</th>
                    <th scope="col">累積天數</th>
                    <th scope="col">平均發電效率</th>
                    <th scope="col">掛錶日</th>
                    <th scope="col">到期天數</th>
                    <th scope="col">發電曲線</th>
                </tr>
            </thead>
            <tbody>
                <detail v-for="item in filteredProject" v-bind:project="item" v-bind:key="item.pid" v-on:getChecked="getCheckedGroup" v-bind:checked="checked"></detail>
            </tbody>
        </table>
    </div>
    <div class="col-12">
        <h3>混合案場狀態</h3>
    </div>
    <div class="col-12 mt-2">
        <table class="table">
            <thead class="thead-light">
                <tr>
                    <th scope="col">選取</th>
                    <th scope="col">#</th>
                    <th scope="col">地點</th>
                    <th scope="col">安裝量</th>
                    <th scope="col">即時發電量</th>
                    <th scope="col">今日度數</th>
                    <th scope="col">日發電效率</th>
                    <th scope="col">累積度數</th>
                    <th scope="col">累積天數</th>
                    <th scope="col">平均發電效率</th>
                    <th scope="col">掛錶日</th>
                    <th scope="col">到期天數</th>
                    <th scope="col">發電曲線</th>
                </tr>
            </thead>

            <tbody>
                <mix v-for="item in project" v-bind:project="item" v-bind:key="item.id"></mix>
            </tbody>
        </table>
    </div>
</div>
</template>

<script>
import detail from "@/components/TotalDetail";
import mix from "@/components/TotalMix";
import {
    apiAll
} from "@/assets/js/api";

export default {
    name: "Total",
    components: {
        detail,
        mix
    },
    data() {
        return {
            data: "",
            visible: '0',
            checked: [],
            isLoading: false,
            project: "",
        };
    },
    mounted() {
        this.getApiAll();
    },
    created() {
        const vm = this;
        vm.isLoading = true;
        vm.$http
            .get(process.env.VUE_APP_SOALR_URL + `/api/solar/full`)
            .then(res => {
                vm.isLoading = false;
                vm.data = res.data;
            });
    },
    methods: {
        getLocation: function (location) {
            var newProject = [];
            $.each(this.data, function (index, value) {
                // if equal to 
                if (value.pid.substring(7, 8) == location) {
                    newProject.push(value);
                }
            });
            return newProject;
        },
        getStaff: function (staff) {
            var newProject = [];
            $.each(this.data, function (index, value) {
                // if equal to 
                if (value.staff == staff) {
                    newProject.push(value);
                }
            });
            return newProject;
        },
        getChecked: function () {
            var newProject = [];
            var vm = this;
            $.each(this.data, function (index, value) {
                // if equal to 
                if (vm.checked.indexOf(value.pid) != -1) {
                    newProject.push(value);
                }
            });
            return newProject;
        },
        getCheckedGroup: function (pid) {
            var flag = this.checked.indexOf(pid);

            if (flag == -1) {
                this.checked.push(pid);
            } else {
                this.checked.splice(flag, 1);
            }
        },
        getApiAll() {
            let my = this;
            apiAll().then((res) => {
                let rs = res.data;
                this.project = rs;
            });
        },
    },
    computed: {
        filteredProject: function () {
            switch (this.visible) {
                case '0':
                    return this.data;
                    break;
                case '1':
                    return this.getLocation(1);
                    break;
                case '2':
                    return this.getLocation(2);
                    break;
                case '3':
                    return this.getLocation(3);
                    break;
                case '4':
                    return this.getLocation(4);
                    break;
                case '5':
                    return this.getLocation(5);
                    break;
                case '6':
                    return this.getLocation(6);
                    break;
                case '7':
                    return this.getLocation(7);
                    break;
                case '8':
                    return this.getLocation(8);
                    break;
                case 'A':
                    return this.getLocation('A');
                    break;
                case 'F':
                    return this.getLocation('F'); // 工廠
                    break;
                case 'Z':
                    return this.getStaff(2); // kevin
                    break;
                case 'X':
                    return this.getStaff(3); // 信宇
                    break;
                case 'ch':
                    return this.getChecked(); // 選擇
                    break;
            }
        },
    }
};
</script>

<style lang="scss" scoped>
@import "~bootstrap/scss/bootstrap";

table {
    font-family: "Helvetica Neue", Helvetica, Arial, sans-serif;
    text-align: center;

    th {
        font-size: 14px;
    }

    td {
        font-size: 12px;
    }
}
</style>
